export const isObject = val => val && typeof val === 'object' && val.constructor === Object;

export const isEmpty = obj => Object.keys(obj).length === 0;



// WEBPACK FOOTER //
// ./src/utilities/typeChecking.js